module.exports = __webpack_public_path__ + "media/_archive/3-15ba6a76.png";